import styled from 'styled-components';
import { color, fontSize, fontWeight, screen, spacing } from '../../../theme';

export const StyledSkillsItem = styled.li`
  display: grid;
  grid-template-columns: 3.5rem 1fr;
  column-gap: ${spacing('md')};
  text-align: left;
  border-top: 1px solid ${color('midnight_200')};
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};

  &:first-child {
    margin-top: ${spacing('lg')};
  }

  &:last-child {
    padding-bottom: 0;
  }

  @media (min-width: ${screen('md')}) {
    height: 3.5rem + ${spacing('md')} * 2;

    &:last-child {
      height: 3.5rem + ${spacing('md')};
    }
  }
`;

export const StyledSkillsItemIcon = styled.img`
  grid-row: span 2;
  display: block;
  width: 3.5rem;
  max-height: 3.5rem;
  align-self: center;
  filter: grayscale(100%);
`;

export const StyledSkillsItemTitle = styled.h5`
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('md')};
  margin-top: 0;
  margin-bottom: ${spacing('xs2')};
`;

export const StyledSkillsItemLevel = styled.figure`
  display: flex;
  align-items: center;
  margin: 0;
`;

export const StyledSkillsItemLevelLadder = styled.div`
  --level1: ${color('sand_150')};
  --level2: ${color('sand_150')};
  --level3: ${color('sand_150')};
  --level-gradient: linear-gradient(
    to right,
    var(--level1),
    var(--level1) ${spacing('md')},
    transparent ${spacing('md')},
    transparent calc(${spacing('md')} + ${spacing('xs2')}),
    var(--level2) calc(${spacing('md')} + ${spacing('xs2')}),
    var(--level2) calc(${spacing('md')} + ${spacing('xs2')} + ${spacing('md')}),
    transparent calc(${spacing('md')} + ${spacing('xs2')} + ${spacing('md')}),
    transparent
      calc(
        ${spacing('md')} + ${spacing('xs2')} + ${spacing('md')} +
          ${spacing('xs2')}
      ),
    var(--level3)
      calc(
        ${spacing('md')} + ${spacing('xs2')} + ${spacing('md')} +
          ${spacing('xs2')}
      )
  );
  width: 3.5rem;
  height: ${spacing('md')};
  margin-right: ${spacing('xs')};
  clip-path: polygon(0 100%, 100% 0, 100% 100%);
  background-image: var(--level-gradient);
  &.level_1 {
    --level1: ${color('positive_500')};
  }
  &.level_2 {
    --level1: ${color('positive_500')};
    --level2: ${color('positive_500')};
  }
  &.level_3 {
    --level1: ${color('positive_500')};
    --level2: ${color('positive_500')};
    --level3: ${color('positive_500')};
  }
`;

export const StyledSkillsItemLevelCaption = styled.figcaption`
  font-size: ${fontSize('xs')};
  text-transform: uppercase;
  line-height: 1;
  color: ${color('text_subtle')};

  @media (max-width: ${screen('mdMax')}) {
    margin-top: ${spacing('xs')};
  }
`;
